<header class="o-widget__header">
  <h1 class="o-widget__heading">Mandanten-Widget</h1>
  <p class="o-widget__subline">Kurzbericht aller Unternehmen</p>
</header>
<div class="o-widget__body">
  <p>Schaden der einzelnen Unternehmen</p>
  <p>Warnung, wenn Konzern gefährdet ist</p>
</div>
